<template>
  <div class="summary">
    <div class="form-section">
      <h4>Summary</h4>
      <HotelItineraryBook :is-edit="true" :hotels="hotels" @edit="edit" />
      <h4>Rates</h4>
      <div v-for="(leg, index) in hotels.route" :key="index">
        <div class="item">
          <div class="line title refundable" :class="{ yes: leg.ideal.is_refundable }">
            <div>{{ leg.ideal.refund_description }}</div>
          </div>
          <div class="breakdown">
            <div class="row">
              <div>
                {{ rooms(leg.ideal.rooms) }} x
                {{ utilDurationAccommodationNights(leg.ideal.checkin, leg.ideal.checkout) }}
              </div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_total_base) }}
              </div>
            </div>
            <div class="row muted">
              <div>Taxes &amp; Fees</div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_total_taxes_and_fees) }}
              </div>
            </div>
            <div v-if="leg.ideal.price_property_mandatory_fee > 0" class="row muted">
              <div>Local Fee</div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_property_mandatory_fee) }}
              </div>
            </div>
            <div v-if="leg.ideal.price_property_resort_fee > 0" class="row muted">
              <div>Resort Fee</div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_property_resort_fee) }}
              </div>
            </div>
            <div v-if="leg.ideal.price_property_mandatory_tax > 0" class="row muted">
              <div>Local Tax</div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_property_mandatory_tax) }}
              </div>
            </div>
            <div class="row total">
              <div>Total</div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_total) }}
              </div>
            </div>
            <div v-if="leg.ideal.price_total_pay_property > 0" class="row sub now">
              <div>Pay Now</div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_total_pay_now) }}
              </div>
            </div>
            <div v-if="leg.ideal.price_total_pay_property > 0" class="row muted">
              <div>Pay At Property</div>
              <div class="amt">
                {{ priceLabel(leg.ideal.price_currency_symbol, leg.ideal.price_currency, leg.ideal.price_total_pay_property) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="navigation">
      <button @click="next">Next Step</button>
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import HotelItineraryBook from "./TripNewBookSummaryHotelBook.vue";
import DateTime from "../utils/datetime";

const { utilDurationAccommodationNights } = DateTime();

// Define props and emits
const props = defineProps(["hotels", "isSavedHotels", "isSavedRoute", "legIndex"]);
const emit = defineEmits(["update:isSavedHotels", "update:isSavedRoute", "update:hotels", "update:legIndex", "complete", "scroll"]);

// Methods
const back = () => {
  emit("update:isSavedHotels", false);
  emit("update:isSavedRoute", false);
};

const edit = index => {
  emit("update:legIndex", index);
  emit("update:isSavedHotels", false);
};

const next = () => {
  var validated = true;

  if (validated === false) {
    alert("Please answer the question before continuing.");
  } else {
    var newHotels = props.hotels;
    emit("update:hotels", newHotels);
    emit("complete");
    emit("scroll");
  }
};

const priceLabel = (sym, curr, p) => {
  var prefix = sym ? sym : curr;
  return (
    prefix +
    parseFloat(parseFloat(p).toFixed(2)).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      useGrouping: true,
    })
  );
};

const rooms = rooms => {
  if (rooms.length == 1) {
    return "1 Room";
  }
  return rooms.length + " Rooms";
};
</script>

<style lang="less">
#hotels {
  .summary {
    .refundable {
      color: @secondary;

      &.yes {
        color: @green;
      }
    }

    .breakdown {
      .row {
        display: flex;
        margin-bottom: 0.125rem;
      }

      .now,
      .total {
        padding-top: 1rem;
      }

      .amt {
        flex: 1;
        text-align: right;
      }
    }
  }
}
</style>
